import React from 'react';

const Icon = (props) => (
  <svg version="1.1" viewBox="0 0 5.924 5.9955" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="m0.14065 5.6248c0.07736-0.20392 0.60766-1.5453 1.1784-2.9809l1.0378-2.6102 1.1855-0.03368 1.1298 2.8346c0.62138 1.5591 1.1572 2.908 1.1908 2.9978l0.06101 0.16314h-1.338l-0.10955-0.31144c-0.06025-0.17129-0.16088-0.45159-0.22361-0.62288l-0.11406-0.31144h-2.3558l-0.11406 0.31144c-0.06273 0.17129-0.16336 0.45159-0.22361 0.62288l-0.10955 0.31144h-1.3357zm3.6506-1.8469c0-0.056828-0.78753-2.2065-0.82194-2.2436-0.02132-0.02299-0.20965 0.44418-0.41851 1.0381-0.20886 0.59396-0.39179 1.1133-0.4065 1.1541-0.02059 0.057082 0.1659 0.074153 0.8101 0.074153 0.46027 0 0.83686-0.010252 0.83686-0.022783z" />
  </svg>
);

export default Icon;
